import { render } from "./BeforeYouBegin.vue?vue&type=template&id=f9bf0dac&scoped=true"
import script from "./BeforeYouBegin.vue?vue&type=script&lang=js"
export * from "./BeforeYouBegin.vue?vue&type=script&lang=js"

import "./BeforeYouBegin.vue?vue&type=style&index=0&id=f9bf0dac&scoped=true&lang=scss"

import exportComponent from "/home/biktorgj/Projects/Linube Cloud/Server_and_UI/ui-prod-4.22/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9bf0dac"]])

export default __exports__